import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @error:
// ErrRoleConflict
// @gen: t=add_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.AddRoleReq, b: any) => Promise<rbacv2.AddRoleRsp>} TypeScript syntax */

export function AddRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// @gen: t=del_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.DelRoleReq, b: any) => Promise<rbacv2.DelRoleRsp>} TypeScript syntax */

export function DelRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// @gen: t=set_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.SetRoleReq, b: any) => Promise<rbacv2.SetRoleRsp>} TypeScript syntax */

export function SetRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#list

/** @type {(r: rbacv2.GetRoleListReq, b: any) => Promise<rbacv2.GetRoleListRsp>} TypeScript syntax */

export function GetRoleList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMenuPathActionConflict path+action已存在
// ErrParentMenuNotFound
// @gen: t=add_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.AddMenuReq, b: any) => Promise<rbacv2.AddMenuRsp>} TypeScript syntax */

export function AddMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMenuPathActionConflict path+action已存在
// ErrMenuNotFound
// @gen: t=set_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.SetMenuReq, b: any) => Promise<rbacv2.SetMenuRsp>} TypeScript syntax */

export function SetMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCanNotDelNotLeafMenu
// ErrMenuNotFound
// @gen: t=del_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.DelMenuReq, b: any) => Promise<rbacv2.DelMenuRsp>} TypeScript syntax */

export function DelMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.GetMenuTreeReq, b: any) => Promise<rbacv2.GetMenuTreeRsp>} TypeScript syntax */

export function GetMenuTree(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetMenuTree",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#list_user

/** @type {(r: rbacv2.GetRoleUserListReq, b: any) => Promise<rbacv2.GetRoleUserListRsp>} TypeScript syntax */

export function GetRoleUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleUserList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 把一批用户加到某个管理组中
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit_user

/** @type {(r: rbacv2.AddUsersToRoleReq, b: any) => Promise<rbacv2.AddUsersToRoleRsp>} TypeScript syntax */

export function AddUsersToRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddUsersToRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 把一批用户，从管理组中移除
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit_user

/** @type {(r: rbacv2.DelUsersFromRoleReq, b: any) => Promise<rbacv2.DelUsersFromRoleRsp>} TypeScript syntax */

export function DelUsersFromRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelUsersFromRole",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 设置单个用户的管理组
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit_user

/** @type {(r: rbacv2.SetUserRolesReq, b: any) => Promise<rbacv2.SetUserRolesRsp>} TypeScript syntax */

export function SetUserRoles(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetUserRoles",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 一次性设置整个菜单权限
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin
// svr options: (ext.Perm) = rbac/role#edit_perm

/** @type {(r: rbacv2.SetRolePermReq, b: any) => Promise<rbacv2.SetRolePermRsp>} TypeScript syntax */

export function SetRolePerm(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRolePerm",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.GetRolePermReq, b: any) => Promise<rbacv2.GetRolePermRsp>} TypeScript syntax */

export function GetRolePerm(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRolePerm",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 内部加管理组，主要是放行 readonly 这类内部选项
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.AddRoleInternalReq, b: any) => Promise<rbacv2.AddRoleInternalRsp>} TypeScript syntax */

export function AddRoleInternal(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddRoleInternal",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取内部的管理组列表
// @error:
// @gen:t=get_model_list
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.GetRoleListInternalReq, b: any) => Promise<rbacv2.GetRoleListInternalRsp>} TypeScript syntax */

export function GetRoleListInternal(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleListInternal",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.AddMenuApiMapReq, b: any) => Promise<rbacv2.AddMenuApiMapRsp>} TypeScript syntax */

export function AddMenuApiMap(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddMenuApiMap",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.GetMenuApiMapListReq, b: any) => Promise<rbacv2.GetMenuApiMapListRsp>} TypeScript syntax */

export function GetMenuApiMapList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetMenuApiMapList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.DelMenuApiMapReq, b: any) => Promise<rbacv2.DelMenuApiMapRsp>} TypeScript syntax */

export function DelMenuApiMap(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelMenuApiMap",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.ReplaceMenuApiMapReq, b: any) => Promise<rbacv2.ReplaceMenuApiMapRsp>} TypeScript syntax */

export function ReplaceMenuApiMap(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/ReplaceMenuApiMap",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrRoleConflict
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.AddRoleWithPermReq, b: any) => Promise<rbacv2.AddRoleWithPermRsp>} TypeScript syntax */

export function AddRoleWithPerm(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddRoleWithPerm",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.SetRoleWithPermReq, b: any) => Promise<rbacv2.SetRoleWithPermRsp>} TypeScript syntax */

export function SetRoleWithPerm(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRoleWithPerm",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @ignore: all
// svr options: (ext.UserType) = admin

/** @type {(r: rbacv2.GetMyRoleInfoReq, b: any) => Promise<rbacv2.GetMyRoleInfoRsp>} TypeScript syntax */

export function GetMyRoleInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetMyRoleInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotPermit
// @gen: t=del_model_db_proxy
// @ignore: all

/** @type {(r: rbacv2.DelInternalRoleReq, b: any) => Promise<rbacv2.DelInternalRoleRsp>} TypeScript syntax */

export function DelInternalRole(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelInternalRole",
    "auth": "1"
  }), o));
}
; // @error:
// ErrNotPermit

/** @type {(r: rbacv2.SetRoleInternalReq, b: any) => Promise<rbacv2.SetRoleInternalRsp>} TypeScript syntax */

export function SetRoleInternal(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRoleInternal",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrParentMenuNotFound
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.AddMenuV2Req, b: any) => Promise<rbacv2.AddMenuV2Rsp>} TypeScript syntax */

export function AddMenuV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddMenuV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMenuNotFound
// ErrInvalidParam
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.EditMenuV2Req, b: any) => Promise<rbacv2.EditMenuV2Rsp>} TypeScript syntax */

export function EditMenuV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/EditMenuV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrCanNotDelNotLeafMenu
// ErrMenuNotFound
// ErrInvalidParam
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.DelMenuV2Req, b: any) => Promise<rbacv2.DelMenuV2Rsp>} TypeScript syntax */

export function DelMenuV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelMenuV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.GetMenuTreeV2Req, b: any) => Promise<rbacv2.GetMenuTreeV2Rsp>} TypeScript syntax */

export function GetMenuTreeV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetMenuTreeV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: menu
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.EditMenuEnableEnvReq, b: any) => Promise<rbacv2.EditMenuEnableEnvRsp>} TypeScript syntax */

export function EditMenuEnableEnv(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/EditMenuEnableEnv",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 添加角色
// @error:
// @gen_to: role
// svr options: (ext.UserType) = staff
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.AddRoleV2Req, b: any) => Promise<rbacv2.AddRoleV2Rsp>} TypeScript syntax */

export function AddRoleV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/AddRoleV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 删除角色
// @error:
// @gen_to: role
// svr options: (ext.UserType) = staff
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.DelRoleV2Req, b: any) => Promise<rbacv2.DelRoleV2Rsp>} TypeScript syntax */

export function DelRoleV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/DelRoleV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 修改角色
// @error:
// @gen_to: role
// svr options: (ext.UserType) = staff
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.SetRoleV2Req, b: any) => Promise<rbacv2.SetRoleV2Rsp>} TypeScript syntax */

export function SetRoleV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRoleV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取角色列表
// @error:
// @gen_to: role
// svr options: (ext.UserType) = staff
// svr options: (ext.Perm) = rbac/role#edit

/** @type {(r: rbacv2.GetRoleListV2Req, b: any) => Promise<rbacv2.GetRoleListV2Rsp>} TypeScript syntax */

export function GetRoleListV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleListV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 根据角色ID获取角色权限
// @error:
// @gen_to: role_perm
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.GetRoleMenuByRoleIdReq, b: any) => Promise<rbacv2.GetRoleMenuByRoleIdRsp>} TypeScript syntax */

export function GetRoleMenuByRoleId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleMenuByRoleId",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 设置角色权限
// @error:
// @gen_to: role_perm
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.SetRolePermV2Req, b: any) => Promise<rbacv2.SetRolePermV2Rsp>} TypeScript syntax */

export function SetRolePermV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRolePermV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 设置角色用户
// @error:
// @gen_to: role_perm
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.SetRoleUserV2Req, b: any) => Promise<rbacv2.SetRoleUserV2Rsp>} TypeScript syntax */

export function SetRoleUserV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/SetRoleUserV2",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 根据角色ID获取角色组成员信息
// @error:
// @gen_to: role_perm
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.GetRoleUserByRoleIdReq, b: any) => Promise<rbacv2.GetRoleUserByRoleIdRsp>} TypeScript syntax */

export function GetRoleUserByRoleId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRoleUserByRoleId",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role_perm
// svr options: (ext.UserType) = staff

/** @type {(r: rbacv2.GetRolePermByRoleIdWithUserReq, b: any) => Promise<rbacv2.GetRolePermByRoleIdWithUserRsp>} TypeScript syntax */

export function GetRolePermByRoleIdWithUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRolePermByRoleIdWithUser",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: role_perm

/** @type {(r: rbacv2.GetRolePermByRoleIdReq, b: any) => Promise<rbacv2.GetRolePermByRoleIdRsp>} TypeScript syntax */

export function GetRolePermByRoleId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/rbacv2/GetRolePermByRoleId",
    "auth": "1"
  }), o));
}
;
var Rbacv2Services = {
  AddRole: AddRole,
  DelRole: DelRole,
  SetRole: SetRole,
  GetRoleList: GetRoleList,
  AddMenu: AddMenu,
  SetMenu: SetMenu,
  DelMenu: DelMenu,
  GetMenuTree: GetMenuTree,
  GetRoleUserList: GetRoleUserList,
  AddUsersToRole: AddUsersToRole,
  DelUsersFromRole: DelUsersFromRole,
  SetUserRoles: SetUserRoles,
  SetRolePerm: SetRolePerm,
  GetRolePerm: GetRolePerm,
  AddRoleInternal: AddRoleInternal,
  GetRoleListInternal: GetRoleListInternal,
  AddMenuApiMap: AddMenuApiMap,
  GetMenuApiMapList: GetMenuApiMapList,
  DelMenuApiMap: DelMenuApiMap,
  ReplaceMenuApiMap: ReplaceMenuApiMap,
  AddRoleWithPerm: AddRoleWithPerm,
  SetRoleWithPerm: SetRoleWithPerm,
  GetMyRoleInfo: GetMyRoleInfo,
  DelInternalRole: DelInternalRole,
  SetRoleInternal: SetRoleInternal,
  AddMenuV2: AddMenuV2,
  EditMenuV2: EditMenuV2,
  DelMenuV2: DelMenuV2,
  GetMenuTreeV2: GetMenuTreeV2,
  EditMenuEnableEnv: EditMenuEnableEnv,
  AddRoleV2: AddRoleV2,
  DelRoleV2: DelRoleV2,
  SetRoleV2: SetRoleV2,
  GetRoleListV2: GetRoleListV2,
  GetRoleMenuByRoleId: GetRoleMenuByRoleId,
  SetRolePermV2: SetRolePermV2,
  SetRoleUserV2: SetRoleUserV2,
  GetRoleUserByRoleId: GetRoleUserByRoleId,
  GetRolePermByRoleIdWithUser: GetRolePermByRoleIdWithUser,
  GetRolePermByRoleId: GetRolePermByRoleId
};
export default Rbacv2Services;